import React from 'react';
import { Link } from 'react-router-dom';
import PublicSEO from '../../components/public/PublicSEO';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';

export default function IntegrazioniPage() {
  return (
    <div className="vc-guide">
      <PublicSEO
        title="Integrazioni API FHIR"
        description="API FHIR R4 sandbox di Virtual Clinic: Schedule, Slot, Appointment, autenticazione X-Api-Key e webhook firmati."
        canonicalPath="/integrazioni"
        jsonLd={[
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Integrazioni' },
          ]),
        ]}
      />
      <div className="vc-guide__inner">
        <h1>Integrazioni</h1>
        <p className="vc-guide__lead">
          Per gestionali e partner tecnici: sandbox HL7 FHIR R4 su risorse di agenda e appuntamento.
        </p>

        <section>
          <h2>Endpoint</h2>
          <ul>
            <li><code>GET /api/v1/fhir/r4/metadata</code> — CapabilityStatement (senza chiave)</li>
            <li><code>GET /api/v1/fhir/r4/Schedule</code> · <code>Slot</code> · <code>Appointment</code></li>
            <li><code>POST/PUT /api/v1/fhir/r4/Appointment</code></li>
          </ul>
        </section>

        <section>
          <h2>Autenticazione</h2>
          <p>
            Header <code>X-Api-Key</code> (oppure Bearer). Le chiavi si creano dall&apos;hub struttura
            dopo l&apos;accesso con ruolo struttura.
          </p>
        </section>

        <section>
          <h2>Webhook in uscita</h2>
          <p>
            Eventi appuntamento con header <code>X-VC-Event</code> e firma
            <code> X-VC-Signature: sha256=&lt;hmac&gt;</code> sul body JSON.
          </p>
          <div className="vc-guide__cta-row">
            <a href="/scalar" className="vc-guide__cta">Apri Scalar</a>
            <Link to={publicPath('/per-le-strutture')} className="vc-guide__cta vc-guide__cta--secondary">
              Per le strutture
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
